import React from "react";
import "./ImpactStatsComponent.scss";

export default function ImpactStatsComponent() {
    return (
        <div className="impact-stats">
            <div className="impact-stats__background">
                <div className="container">
                    <h2 className="impact-stats__title">Our Impact</h2>
                    
                    <div className="impact-stats__stats-container">
                        <div className="impact-stats__stat-item">
                            <div className="impact-stats__stat-number-container">
                                <span className="impact-stats__stat-number count-up">7,000</span>
                                <span className="impact-stats__stat-plus">+</span>
                            </div>
                            <div className="impact-stats__stat-label">
                                <span>Happy Customers</span>
                            </div>
                        </div>
                        
                        <div className="impact-stats__divider"></div>
                        
                        <div className="impact-stats__stat-item">
                            <div className="impact-stats__stat-number-container">
                                <span className="impact-stats__stat-number count-up">50</span>
                                <span className="impact-stats__stat-plus">+</span>
                            </div>
                            <div className="impact-stats__stat-label">
                                <span>Premium Vehicles</span>
                            </div>
                        </div>
                        
                        <div className="impact-stats__divider"></div>
                        
                        <div className="impact-stats__stat-item">
                            <div className="impact-stats__stat-number-container">
                                <span className="impact-stats__stat-number count-up">100</span>
                                <span className="impact-stats__stat-plus">+</span>
                            </div>
                            <div className="impact-stats__stat-label">
                                <span>City Destinations</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
